<template>
  <div>
    <div v-if="!readOnly" class="op">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form class="b-layout" @submit.prevent="">
      <div v-if="operationSelected">
        <div class="inp">
          <label>{{ $t('umidade-de-levedura-na-saida') }}</label>
          <input
            v-model="Xo.value"
            type="number"
            step="0.01"
            min="0"
            max="100"
          />
        </div>
        <div class="inp">
          <label>{{ $t('ocupacao-1') }}</label>
          {{ taxaOcupacao.value | ParseNumber }}
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { FiltersMixin } from '../../../mixins/filtersMixin';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  mixins: [ FiltersMixin ],

  data() {
    return {
      operationAttributeList: [],
      operations: [{ value: null, text:this.$t('selecione-uma-operacao-0') }],
      attributesList: [],
      operationSelected: null,
      firstLoad: false,
      attrList: ["Xo", "taxaOcupacao"],
      Xo: {},
      taxaOcupacao: {},
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(
        this.operationSelected
      ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
      this.updateNode();
    },

    "Xo.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
        this.loadNotInput();
      }

      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }
      });
    },

    loadNotInput() {
      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(
        this.operationSelected
      ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(1);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    updateNode() {
      this.node.attrs = [this.Xo.clone()];
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/SDR/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.op {
  margin: 2%;
}
</style>
